"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _Modal = require("@insided/shared/uikit/Modal");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _preactPortal = _interopRequireDefault(require("preact-portal"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MovedLink = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(MovedLink, _Component);

  var _super = _createSuper(MovedLink);

  function MovedLink(props) {
    var _this;

    (0, _classCallCheck2.default)(this, MovedLink);
    _this = _super.call(this, props);
    _this.state = {
      isOpen: false
    };
    return _this;
  }

  (0, _createClass2.default)(MovedLink, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          normalizedLabel = _this$props.normalizedLabel,
          label = _this$props.label,
          redirectLink = _this$props.redirectLink,
          message = _this$props.message;
      var isOpen = this.state.isOpen;
      return (0, _preact.h)("li", {
        className: "navigation-menu__item--".concat(normalizedLabel)
      }, (0, _preact.h)("a", {
        onKeyPress: function onKeyPress() {},
        onClick: function onClick() {
          _this2.setState({
            isOpen: true
          });
        }
      }, label), isOpen && (0, _preact.h)(_preactPortal.default, {
        into: "body"
      }, (0, _preact.h)(_Modal.Modal, {
        isOpen: isOpen,
        size: "medium"
      }, (0, _preact.h)(_Modal.ModalHeader, {
        title: "Page moved",
        onClose: function onClose() {
          _this2.setState({
            isOpen: false
          });
        }
      }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)("p", null, message)), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_Button.default, {
        title: "Take me there",
        variant: "primary",
        onClick: function onClick() {
          window.location.href = redirectLink;
        },
        size: "medium"
      }), (0, _preact.h)(_Button.default, {
        title: "Cancel",
        onClick: function onClick() {
          _this2.setState({
            isOpen: false
          });
        },
        size: "medium"
      })))));
    }
  }]);
  return MovedLink;
}(_preact.Component);

var _default = MovedLink;
exports.default = _default;